const stringFormat = (template, ...args) =>
  template.replace(/{(\d+)}/g, (match, index) => {
    const value = args[Number(index)];
    return value !== undefined && value !== null ? value : match;
  });

export default stringFormat;